import get from 'lodash/get';
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { NEW_GROUP_ID } from '../../../../common/constants';
import type { Group } from '../../../../common/types';
import { getGroupsSelector } from '../../selectors';
import type { ImmutableState } from '../../types';
import { setGroupsMutator } from '../utils';

const updateNewGroup =
	(newGroup: Group, template: Group) =>
	({ getState, setState }: StoreActionApi<ImmutableState>): void => {
		const state = getState();
		const groups = getGroupsSelector(state).slice();
		const templateIndex = groups.indexOf(template);

		if (templateIndex >= 0) {
			const { id: newId } = newGroup;
			// Deconstructing group template's ticket types and other groups ticket types
			const { [NEW_GROUP_ID.toString()]: ticketTypesForTemplate, ...ticketTypesForExistingGroups } =
				state.ticketTypesByGroup;

			// Updating ticketTypesByGroup with created group id
			const updatedTicketTypesByGroup = {
				...ticketTypesForExistingGroups,
				[newId]: ticketTypesForTemplate,
			};

			// Updating groupsByTicketType with created group id
			const updatedGroupsByTicketTypes = ticketTypesForTemplate.reduce(
				(acc, ticketTypeId) => ({
					// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
					...acc,
					[ticketTypeId]: [...get(acc, ticketTypeId, []), newId],
				}),
				state.groupsByTicketType,
			);

			// Replace template group newly created group
			groups[templateIndex] = newGroup;

			setState({
				...setGroupsMutator(groups, state),
				ticketTypesByGroup: updatedTicketTypesByGroup,
				groupsByTicketType: updatedGroupsByTicketTypes,
				lastCreatedGroup: newGroup.id,
			});
		}
	};

export default updateNewGroup;
